export default "__VITE_ASSET__6cb0f94d__"